export const QUEBEC_CITIES = [
  "Montréal",
  "Québec",
  "Laval",
  "Longueuil",
  "Gatineau",
  "Sherbrooke",
  "Saguenay",
  "Lévis",
  "Trois-Rivières",
  "Terrebonne",
  "Saint-Jean-sur-Richelieu",
  "Repentigny",
  "Brossard",
  "Drummondville",
  "Saint-Jérôme",
  "Granby",
  "Blainville",
  "Saint-Hyacinthe",
  "Shawinigan",
  "Dollard-des-Ormeaux",
  "Châteauguay",
  "Rimouski",
  "Rouyn-Noranda",
  "Côte-Saint-Luc",
  "Mascouche",
  "Mirabel",
  "Victoriaville",
  "Val-d'Or",
  "Baie-Comeau",
  "Saint-Eustache",
  "Sorel-Tracy",
  "Westmount",
  "Sept-Îles",
  "Mont-Royal",
  "Salaberry-de-Valleyfield",
  "Pointe-Claire",
  "Joliette",
  "Beloeil",
  "Saint-Georges",
  "La Prairie",
  "Vaudreuil-Dorion",
  "Boucherville",
  "Sainte-Julie",
  "Sainte-Thérèse",
  "Thetford Mines",
  "Chibougamau",
  "Varennes",
  "L'Assomption",
  "Sainte-Marie",
  "Alma",
];

